export const MEDIA_TYPE_IMAGE = 'image';
export const MEDIA_TYPE_VIDEO = 'video';
export const MEDIA_TYPE_GEN_AI = 'gen-ai';
export const MEDIA_TYPE_MPS = 'mps';

export const FILE_ROOT_PATH = 'imageProcessing/';
export const ID_CAPTURED_ASSET_BLOCK = 'capturedAssetBlock';
export const ID_BG_ASSETS_BLOCK = 'bgAssetsBlock';
export const PIPELINE_TYPE_IMAGE = 'image';
export const PIPELINE_TYPE_VIDEO = 'video';
export const PIPELINE_TYPE_GEN_AI = 'gen-ai';
export const PIPELINE_TYPE_MPS = 'mps';

// These are bit values for Kiosk Scan and sum of bits are kept in Backend
export const KIOSK_POST_SCAN = 1;
export const KIOSK_PRE_SCAN = 2;
